import { getLocalTranslation } from '../utils/i18nKit';
export var getButtonShapeList = function getButtonShapeList() {
  var _getLocalTranslation = getLocalTranslation(),
      $t = _getLocalTranslation.$t;

  return [{
    value: 'rounded',
    label: $t('kit:styles.rounded')
  }, {
    value: 'square',
    label: $t('kit:styles.square')
  }];
};